/**
 * Single source of truth for provenance and attribution.
 *
 * Two facts are available on every route: who operates this service, and who
 * published anything it reproduces. That is provenance, the same discipline
 * applied to any cited source. It is not a disclaimer and it is not written in
 * a legal register.
 *
 * The test suite asserts these render on every route, so attribution cannot be
 * dropped quietly.
 */

export const PRODUCT_NAME = 'FITI'
export const PRODUCT_TAGLINE = 'From Idea to Impact'

/** Who operates the service. */
export const OPERATOR = {
  name: 'MetaPhase',
  url: 'https://metaphase.tech',
} as const

/** Whose mission the system serves, and who publishes any source records. */
export const SOURCE = {
  publisher: 'MetaPhase',
} as const

/** How the system was delivered. */
export const DELIVERY =
  'Mission Protoware, built by MPworks and delivered with ChallengeAI.'

/**
 * ChallengeAI is how this was built, never a feature of what was built. Copy
 * that describes a capability as powered by ChallengeAI is wrong.
 */
export const ACCELERATOR =
  'ChallengeAI is the accelerator applied during engineering.'

/** Byline naming the operator. Rendered in the footer on every route. */
export const ATTRIBUTION = `${PRODUCT_NAME} is built and operated by ${OPERATOR.name}.`

export const BUILT_BY = `Built by ${OPERATOR.name}`

export const COPYRIGHT_YEAR = 2026
